export default "__VITE_ASSET__CvI5LwXO__"